import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { Content, TDocumentDefinitions } from "pdfmake/interfaces";
import { convertImageToBase64 } from "../Utils/qr";

pdfMake.vfs = pdfFonts.vfs;

export const sampleBox = async (
    poNo: string,
    supplierName: string,
    store: string,
    returnStore: string,
    attn: string,
    boxQty: number
) => {

    // Convert logos to base64
    const dcImg = await convertImageToBase64("/pdfLogo.png");
    const svpImg = await convertImageToBase64("/pdfLogoBlue.png");

    // Prepare content array
    const Landscapecontent: Content[] = [];

    for (let i = 1; i <= boxQty; i++) {
        Landscapecontent.push({
            columns: [
                { text: '',  alignment: "left", opacity: 0.7 },
                { image: svpImg, height: 40, width: 80, alignment: "center" },
                { text: '',  alignment: "left", opacity: 0.7 },
                // { image: dcImg, height: 25, width: 40, alignment: "right", opacity: 0.7 },
            ],
            columnGap: 280,
            margin: [0, -25, 0, 5],
        });

        Landscapecontent.push({
            stack: [
                {
                    text: `ATTN: ${attn}`,
                    fontSize: 70,
                    bold: true,
                    alignment: "center",
                    margin: [0, 0, 0, 10],
                    background: "#fff200",
                    color: 'red',
                },
                { text: `#PO: ${poNo}`, fontSize: 25, alignment: "center", margin: [0, 20, 0, 10] },
                { text: `Supplier: ${supplierName}`, fontSize: 25, alignment: "center" },
                { text: `${store} SAMPLE BOX`, fontSize: 70, alignment: "center", bold: true, background: "#fff420", color: 'red', margin: [0, 10, 0, 10] },
                {
                    columns: [
                        {
                            text: `Box: ${i} / ${boxQty}`,
                            fontSize: 25,
                            bold: true,
                            alignment: "center",
                            //   color: "#444",
                            margin: [0, 20, 0, 0],
                        },
                        {
                            text: `Date: ${new Date().toLocaleDateString()}`,
                            fontSize: 25,
                            bold: true,
                            alignment: "center",
                            margin: [0, 20, 0, 0],
                        }
                    ]
                },
                {
                    text: '',
                    bold: true,
                    //  colSpan:2,
                    color: 'red',
                    alignment: 'center',
                    margin: [0, 40, 0, 0],
                },
                {
                    table: {
                        widths: ["*", "*"],
                        headerRows: 1,
                        body: [
                            // [
                            //     {}
                            // ],
                            [
                                {
                                    text: `Checked By:`,
                                    fontSize: 20,
                                    bold: true,
                                    alignment: "left",
                                    //   color: "#444",
                                    // margin: [0, 40, 0, 0],
                                },
                                {
                                    text: `Store: ${returnStore || ''} `,
                                    fontSize: 20,
                                    bold: true,
                                    alignment: "left",
                                    // margin: [0, 40, 0, 0],
                                }
                            ]
                        ],
                    },
                },
            ],
            // Add page break except on last page
            pageBreak: i < boxQty ? "after" : undefined,
        });
    }

    const LandscapedocDefinition: TDocumentDefinitions = {
        pageSize: "LETTER",
        pageOrientation: "landscape",
        content: Landscapecontent,
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                alignment: "center",
                margin: [0, 0, 0, 10],
            },
        },
    };

    const pdfDoc = pdfMake.createPdf(LandscapedocDefinition);
    pdfDoc.open();
};